import { createReducer } from '@reduxjs/toolkit'
import { setFinished } from './actions'

const finished = createReducer(false, {
  [setFinished]: (_, action) => action.payload
})

export default finished